import { createStrictContext } from "../../js/react/hooks";
import { AttributeOption, Product } from "./types";

export type ProductContext = {
  product: Product;
  setAttribute: (value: AttributeOption) => void;

  // 🔽 Add these for validation
  errors: Record<string, string>;
  isValidated: boolean;
  validate: () => boolean;
  setErrors: (e: Record<string, string>) => void;
  revalidateOnChange: boolean;
  setRevalidateOnChange: (val: boolean) => void;
};

export const [ProductContextProvider, useProductContext] =
  createStrictContext<ProductContext>();
